<template>
  <!-- HTML 정의하는 부분 -->
  <!-- 1차 퍼블리셔가 작업 영역 -->
  <!-- 2차 개발자가 Template 화 작업 진행-->
  <v-container fluid>
    <v-form
      ref="certificateForm"
    >
      <v-row>
        <v-col class="pt-0" cols="7" md="8">
          <v-text-field :disabled="disableField" ref="phonefield" :rules="[rules.required, rules.isPhoneNumber]" outlined dense hide-details="auto" hint=" _ 제외하고 입력" v-model="phoneNumberF" :label="$t('phone')" placeholder="- 제외하고 입력"></v-text-field>
        </v-col>
        <v-col class="pt-0 pl-0 align-self-center" cols="5" md="4">
          <v-btn outlined class="default-btn" :disabled="disableSendNumber" block @click="sendNumber">인증번호발송</v-btn>
        </v-col>
        <v-col cols="12" class="pt-0" v-show="showCheckNumber">
          <span class="text-caption">카카오톡 알림톡으로 인증번호를 발송했습니다. 발송된 인증번호를 입력해주세요.</span><br>
          <span class="text-caption grey--text">카카오톡이 설치되어 있지 않은 경우 SMS로 자동 발송됩니다.</span><br>
          <span class="text-caption grey--text">카카오톡 채널을 차단하신 경우 알림톡을 받지 못할 수 있습니다.</span><br>
          <span class="text-caption orange--text text--darken-2">인증번호가 수신되지 않는 경우, 가입하신 계정에 본인 휴대폰 번호가 등록되어 있지 않을 수 있습니다. 관리자를 통해 사용자 정보 변경이 필요합니다.</span>
        </v-col>
        <v-col cols="7" md="8" v-if="showCheckNumber">
          <v-text-field :rules="[rules.required]" outlined dense hide-details="auto" v-model="certificateNumber" label="인증번호">
          </v-text-field>
        </v-col>
        <v-col class="pl-0" cols="5" md="4" v-if="showCheckNumber">
          <v-btn outlined class="default-btn" block @click="certificate">인증번호확인</v-btn>
        </v-col>
        <v-col cols="12" class="pt-0" v-show="showCheckNumber">
          <span class="text-caption green--text">{{ curTime }}</span>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
import irules from '@/utils/rules'
import { getRegisterCheck } from '@/api/greenCommon/user'
import Message from '@/utils/message'
import store from '@/store'
import { certificateNumberComplete, sendCertificateByUserId, sendCertificateForFindId } from '@/api/common/user'
export default {
  name: 'PhoneCertificate',
  components: {
  },
  props: {
    phoneNumber: {
      type: String,
      default: ''
    },
    toggleInit: {
      type: Boolean,
      default: true
    },
    createType: { // ID/PW 찾기 시 true, 마이페이지 수정시 false
      type: Boolean,
      default: false
    },
    userId: { // 비밀번호 찾기 전용: 제공 시 user_id 기반 OTP 발송(DB 전화번호 검증)
      type: String,
      default: null
    },
    korNm: { // 아이디 찾기 전용: 제공 시 이름+전화번호 기반 OTP 발송(DB 이름 검증)
      type: String,
      default: null
    }
  },
  data() {
    return {
      valid: true,
      rules: irules,
      phoneNumberF: '',
      fromPhoneNumber: '1111-1111',
      showCheckNumber: false,
      disableSendNumber: false,
      disableField: false,
      isCertificateOk: false, // 인증이 최종 완료된 경우 true
      certificateNumber: '',
      curTime: '',
      timer: ''
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    this.phoneNumberF = this.phoneNumber
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
    if (this.phoneNumber !== undefined && this.phoneNumber !== '') {
      this.disableField = true
      this.$nextTick(() => {
        this.disableSendNumber = !this.$refs.certificateForm.validate()
      })
    }
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
  },
  watch: {
    createType: function() {
      console.log(this.createType)
    },
    phoneNumber: function(value) {
      if (this.phoneNumber !== undefined && this.phoneNumber !== '') {
        this.phoneNumberF = value
        this.disableField = true
      }
    },
    phoneNumberF: function(value) {
      if (this.phoneNumberF !== undefined && this.phoneNumberF !== '') {
        this.$nextTick(() => {
          this.disableSendNumber = !this.$refs.certificateForm.validate()
        })
      }
    },
    isCertificateOk: function (value) {
      if (value) {
        this.$emit('isCertificateOk', this.phoneNumberF)
        // this.$emit('updatePhoneNumber', )
        // this.isCertificateOk = false
      }
    },
    toggleInit: function () {
      this.phoneNumberF = ''
      this.init()
    }
  },
  methods: {
    init() {
      this.stopTimer()
      this.certificateNumber = null
      this.showCheckNumber = false
      this.disableField = false
      this.isCertificateOk = false
      this.disableSendNumber = false
    },
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    startTimer() {
      let time = 180
      this.curTime = (time / 60) + ':' + (time % 60).toString().padStart(2, '0')
      this.timer = setInterval(() => {
        time = time - 1
        this.curTime = Math.floor(time / 60) + ':' + (time % 60).toString().padStart(2, '0')
        if (time === 0) {
          this.init()
          Message.warn('인증시간이 만료되었습니다.')
        }
      }, 1000)
    },
    stopTimer() {
      clearInterval(this.timer)
    },
    sendNumber() {
      const onSuccess = () => {
        this.startTimer()
        this.showCheckNumber = true
        this.disableField = true
        this.isCertificateOk = false
        this.disableSendNumber = true
      }
      const onFail = reject => {
        Message.warn(reject?.response?.data?.result?.desc || '다시 요청해주세요.')
        this.certificateNumber = null
        this.showCheckNumber = false
        this.disableField = false
        this.isCertificateOk = false
      }

      if (this.userId !== null) {
        // 비밀번호 찾기: user_id + 입력 전화번호를 백엔드에 전송 → DB 일치 검증 후 발송
        if (!this.userId) {
          Message.warn('아이디를 입력해주세요.')
          return
        }
        sendCertificateByUserId(this.userId, this.phoneNumberF).then(onSuccess).catch(onFail)
      } else if (this.korNm !== null) {
        // 아이디 찾기: 이름 + 전화번호를 백엔드에 전송 → DB 이름 일치 검증 후 발송
        if (!this.korNm) {
          Message.warn('이름을 입력해주세요.')
          return
        }
        sendCertificateForFindId(this.korNm, this.phoneNumberF).then(onSuccess).catch(onFail)
      } else {
        // 회원가입 / 마이페이지: 사용자 입력 전화번호로 발송
        let params = { phone: this.phoneNumberF }
        getRegisterCheck(params).then(() => {
          store
            .dispatch('SendCertificateNumber', {
              name: this.name,
              fromPhoneNumber: this.phoneNumberF.toString(),
              toPhoneNumber: this.phoneNumberF.toString(),
              createType: this.createType
            })
            .then(onSuccess)
            .catch(onFail)
        })
      }
    },
    certificate() {
      // store.state에 있는 인증번호를 발급받을 당시의 값과 현재 인증 화면에 입력된 값 비교
      // 조건중 하나라도 부합하지 않으면 회원가입 진행할 수 없음
      if (
        this.certificateNumber
      ) {
        certificateNumberComplete(this.certificateNumber.trim())
          .then(res => {
            if (res.body) {
              this.stopTimer()
              this.isCertificateOk = true
              this.showCheckNumber = false
              this.disableField = true
              this.disableSendNumber = true
              Message.info('인증되었습니다.')
              if (this.createType && this.userId === null) {
                store.dispatch('ClearSession')
              }
            } else {
              Message.err('인증번호가 일치하지 않습니다.')
            }
          })
          .catch(reject => {
            // 인증 실행 경고문구 표시
            Message.err('인증번호가 일치하지 않습니다.')
          })
      }
    }
  }
}
</script>

<style scoped>

</style>
